import React, { useEffect } from 'react';

function ErrorPage() {

    useEffect(() => {
        document.title = "Error 404 Page not found | Clozers";
    }, [])

    return (
        <div>
            <h1 className="heading-large-bold colour-primary text-align-center">
                Error 404: Page not found
            </h1>
        </div>
    )
};

export default ErrorPage;